import Vue, { VNodeDirective } from "vue";

class TooltipData {
	enteredTimes:number = 0;
	focused:boolean = false;
	el:HTMLElement;
	tooltip:HTMLDivElement;
	touchStartTime:Date = new Date();
	isTouching:boolean = false;
	isLongtouching:boolean = false;
	isEmpty:boolean = false;

	constructor(el:HTMLElement, value:string){
		this.el = el;
		this.tooltip = document.createElement("div");
		this.tooltip.className = "w-tooltip";
		this.tooltip.innerText = value;
		this.isEmpty = value == undefined;
		el.appendChild(this.tooltip);
	}

	updateDom(){
		if (this.enteredTimes != 0 || this.focused || this.isLongtouching) {
			if (this.isEmpty) return;
			this.tooltip.classList.add("show");
			let box = this.el.getBoundingClientRect();
			let tBox = this.tooltip.getBoundingClientRect();

			let bottom = window.innerHeight - box.top;
			if (window.innerHeight < bottom + tBox.height) {
				this.tooltip.style.top = `${box.bottom}px`;
				this.tooltip.style.bottom = "";
			} else {
				this.tooltip.style.bottom = `${bottom}px`;
				this.tooltip.style.top = "";
			}


			let center = box.left + box.width / 2;
			let left = center - tBox.width / 2;
			if (left < 0) {
				left = 0;
			}
			if (left + tBox.width > window.innerWidth) {
				left = window.innerWidth - tBox.width;
			}
			this.tooltip.style.left = `${left}px`;
		}else{
			this.tooltip.classList.remove("show");
		}
	}
}

Vue.directive("tooltip", {
	// eslint-disable-next-line max-lines-per-function
	bind(el:HTMLElement, binding:VNodeDirective) {
		let data = new TooltipData(el, binding.value);

		el.addEventListener("mouseenter", () => {
			data.enteredTimes++;
			data.isLongtouching = false;
			data.updateDom();
		});
		//el.addEventListener("mouseout", () => {
		//	data.enteredTimes--;
		//	data.isLongtouching = false;
		//	if (data.enteredTimes == 0){
		//		data.focused = false;
		//	}
		//	data.updateDom();
		//});
		el.addEventListener("mouseleave", ()=>{
			data.enteredTimes = 0;
			data.focused = false;
			data.isLongtouching = false;
			data.updateDom();
		});
		el.addEventListener("click", ()=>{
			data.enteredTimes = 0;
			data.focused = false;
			data.isLongtouching = false;
			data.updateDom();
		});
		el.addEventListener("focus", ()=>{
			data.focused = true;
			data.isLongtouching = false;
			data.updateDom();
		});
		el.addEventListener("blur", ()=>{
			data.focused = false;
			data.isLongtouching = false;
			data.updateDom();
		});
		el.addEventListener("touchstart", ()=>{
			// Fix date pickers
			if (el.classList.contains("w-date-picker")){
				setTimeout(()=>{
					data.focused = false;
					data.isLongtouching = false;
					data.enteredTimes = 0;
					data.updateDom();
				}, 200);
				return;
			}

			data.touchStartTime = new Date();
			data.isTouching = true;
			setTimeout(()=>{
				if (data.isTouching){
					data.isLongtouching = true;
					data.updateDom();
				}
			}, 500);
			data.updateDom();
		});
		el.addEventListener("touchmove", ()=>{
			data.isTouching = false;
			data.isLongtouching = false;
			data.updateDom();
		});
		el.addEventListener("touchend", ()=>{
			data.isTouching = false;
			data.updateDom();
		});
	},
	update(el:HTMLElement, binding:VNodeDirective) {
		for (let i = 0; i < el.children.length; i++) {
			let item = el.children.item(i);
			if (!item) continue;
			if (item.classList.contains("w-tooltip")) {
				(item as HTMLDivElement).innerText = binding.value;
				if (binding.value == null) {
					item.classList.add("hidden");
				}else{
					item.classList.remove("hidden");
				}
			}
		}
	}
});